{
 "stage": "kelmore",
 "generator": "src/codriver/generator.ts (curvature segmentation, calibrated grades, vertical profile, props, overrides)",
 "convention": "grade before direction; 1–6 (6 fastest) + square/acute/hairpin/open hairpin, flat; plus/minus thirds; long ≥90°, very long ≥150°",
 "notes": [
  {
   "id": 0,
   "s": 159,
   "sEnd": 248,
   "kind": "corner",
   "pre": [],
   "post": [],
   "tokens": [
    "flat",
    "right"
   ],
   "text": "FLAT RIGHT",
   "dir": "right",
   "limitSpeed": 47.73384143101266,
   "minRadius": 309.80029031234255,
   "angleDeg": 14.20617714663751,
   "grade": "flat",
   "link": "120"
  },
  {
   "id": 1,
   "s": 374,
   "sEnd": 386,
   "kind": "hazard",
   "pre": [
    "crest"
   ],
   "post": [],
   "tokens": [
    "crest"
   ],
   "text": "CREST",
   "link": "40"
  },
  {
   "id": 2,
   "s": 428,
   "sEnd": 538,
   "kind": "corner",
   "pre": [],
   "post": [],
   "tokens": [
    "five",
    "left",
    "long"
   ],
   "text": "5 LEFT · LONG",
   "dir": "left",
   "limitSpeed": 32.12368982583153,
   "minRadius": 145.81893243833144,
   "angleDeg": 33.15449453583265,
   "length": "long",
   "grade": "5",
   "link": "100"
  },
  {
   "id": 3,
   "s": 642,
   "sEnd": 732,
   "kind": "corner",
   "pre": [],
   "post": [],
   "tokens": [
    "four",
    "right",
    "minus",
    "long"
   ],
   "text": "4 RIGHT− · LONG",
   "dir": "right",
   "limitSpeed": 22.846535889562027,
   "minRadius": 77.78822636901941,
   "angleDeg": 49.454150702287905,
   "refine": "minus",
   "length": "long",
   "grade": "4",
   "link": "30"
  },
  {
   "id": 4,
   "s": 763,
   "sEnd": 837,
   "kind": "corner",
   "pre": [],
   "post": [],
   "tokens": [
    "three",
    "left",
    "plus"
   ],
   "text": "3 LEFT+",
   "dir": "left",
   "limitSpeed": 21.17092940553679,
   "minRadius": 67.10226247511206,
   "angleDeg": 41.95099541802054,
   "refine": "plus",
   "grade": "3",
   "link": "and"
  },
  {
   "id": 5,
   "s": 857,
   "sEnd": 921,
   "kind": "corner",
   "pre": [],
   "post": [],
   "tokens": [
    "two",
    "right",
    "plus"
   ],
   "text": "2 RIGHT+",
   "dir": "right",
   "limitSpeed": 17.1173219009637,
   "minRadius": 42.52753814457573,
   "angleDeg": 60.23894243456791,
   "refine": "plus",
   "grade": "2",
   "link": "70"
  },
  {
   "id": 6,
   "s": 991,
   "sEnd": 1003,
   "kind": "hazard",
   "pre": [
    "caution",
    "jump"
   ],
   "post": [],
   "tokens": [
    "caution",
    "jump"
   ],
   "text": "CAUTION · JUMP",
   "link": "40"
  },
  {
   "id": 7,
   "s": 1048,
   "sEnd": 1124,
   "kind": "corner",
   "pre": [
    "rocks"
   ],
   "post": [
    "keep_in",
    "dont_cut"
   ],
   "tokens": [
    "rocks",
    "three",
    "left",
    "minus",
    "tightens",
    "two",
    "keep in",
    "don't cut"
   ],
   "text": "ROCKS · 3 LEFT− · TIGHTENS 2 · KEEP IN · DON'T CUT",
   "dir": "left",
   "limitSpeed": 14.74520724090571,
   "minRadius": 30.710507257791484,
   "angleDeg": 85.438941589662,
   "shape": "tightens",
   "refine": "minus",
   "grade": "3",
   "shapeGrade": "2",
   "link": "and"
  },
  {
   "id": 8,
   "s": 1143,
   "sEnd": 1157,
   "kind": "hazard",
   "pre": [
    "caution",
    "potholes"
   ],
   "post": [],
   "tokens": [
    "caution",
    "potholes"
   ],
   "text": "CAUTION · POTHOLES",
   "link": "80"
  },
  {
   "id": 9,
   "s": 1241,
   "sEnd": 1441,
   "kind": "corner",
   "pre": [],
   "post": [
    "dont_cut"
   ],
   "tokens": [
    "five",
    "right",
    "very long",
    "don't cut"
   ],
   "text": "5 RIGHT · VERY LONG · DON'T CUT",
   "dir": "right",
   "limitSpeed": 31.079082289570913,
   "minRadius": 137.5847234702802,
   "angleDeg": 71.328625259508,
   "length": "very_long",
   "grade": "5",
   "link": "80"
  },
  {
   "id": 10,
   "s": 1526,
   "sEnd": 1538,
   "kind": "hazard",
   "pre": [
    "dip"
   ],
   "post": [],
   "tokens": [
    "dip"
   ],
   "text": "DIP",
   "link": "70"
  },
  {
   "id": 11,
   "s": 1607,
   "sEnd": 1658,
   "kind": "corner",
   "pre": [
    "ruts"
   ],
   "post": [],
   "tokens": [
    "ruts",
    "two",
    "left"
   ],
   "text": "RUTS · 2 LEFT",
   "dir": "left",
   "limitSpeed": 14.583914816206347,
   "minRadius": 29.88939869190875,
   "angleDeg": 61.019277539848694,
   "grade": "2",
   "link": "60"
  },
  {
   "id": 12,
   "s": 1720,
   "sEnd": 1775,
   "kind": "corner",
   "pre": [
    "caution",
    "potholes"
   ],
   "post": [
    "dont_cut"
   ],
   "tokens": [
    "caution",
    "potholes",
    "hairpin",
    "right",
    "don't cut"
   ],
   "text": "CAUTION · POTHOLES · HAIRPIN RIGHT · DON'T CUT",
   "dir": "right",
   "limitSpeed": 9.05333822992485,
   "minRadius": 10.661551824526994,
   "angleDeg": 172.1895986485373,
   "grade": "hairpin",
   "link": "60"
  },
  {
   "id": 13,
   "s": 1840,
   "sEnd": 1888,
   "kind": "corner",
   "pre": [],
   "post": [
    "dont_cut"
   ],
   "tokens": [
    "hairpin",
    "left",
    "don't cut"
   ],
   "text": "HAIRPIN LEFT · DON'T CUT",
   "dir": "left",
   "limitSpeed": 9.599963529170104,
   "minRadius": 11.966130171176673,
   "angleDeg": 167.7199117177502,
   "grade": "hairpin",
   "link": "80"
  },
  {
   "id": 14,
   "s": 1945,
   "sEnd": 1946,
   "kind": "stage",
   "pre": [],
   "post": [],
   "tokens": [
    "split"
   ],
   "text": "SPLIT"
  },
  {
   "id": 15,
   "s": 1970,
   "sEnd": 2030,
   "kind": "corner",
   "pre": [],
   "post": [],
   "tokens": [
    "two",
    "right",
    "plus"
   ],
   "text": "2 RIGHT+",
   "dir": "right",
   "limitSpeed": 16.60687876167376,
   "minRadius": 39.722082161406966,
   "angleDeg": 52.254026662677724,
   "refine": "plus",
   "grade": "2",
   "link": "100"
  },
  {
   "id": 16,
   "s": 2138,
   "sEnd": 2246,
   "kind": "corner",
   "pre": [],
   "post": [],
   "tokens": [
    "five",
    "left",
    "plus",
    "long"
   ],
   "text": "5 LEFT+ · LONG",
   "dir": "left",
   "limitSpeed": 34.53474665222826,
   "minRadius": 166.75499514391606,
   "angleDeg": 29.048504990277948,
   "refine": "plus",
   "length": "long",
   "grade": "5",
   "link": "70"
  },
  {
   "id": 17,
   "s": 2321,
   "sEnd": 2333,
   "kind": "hazard",
   "pre": [
    "crest"
   ],
   "post": [],
   "tokens": [
    "crest"
   ],
   "text": "CREST",
   "link": "60"
  },
  {
   "id": 18,
   "s": 2392,
   "sEnd": 2476,
   "kind": "corner",
   "pre": [
    "over_crest"
   ],
   "post": [
    "dont_cut"
   ],
   "tokens": [
    "over",
    "crest",
    "four",
    "right",
    "minus",
    "don't cut"
   ],
   "text": "OVER CREST · 4 RIGHT− · DON'T CUT",
   "dir": "right",
   "limitSpeed": 23.30679318725362,
   "minRadius": 81.01062678977709,
   "angleDeg": 39.43162331258888,
   "refine": "minus",
   "grade": "4",
   "link": "80"
  },
  {
   "id": 19,
   "s": 2564,
   "sEnd": 2576,
   "kind": "hazard",
   "pre": [
    "double_caution",
    "big_jump"
   ],
   "post": [],
   "tokens": [
    "double caution",
    "big jump"
   ],
   "text": "DOUBLE CAUTION · BIG JUMP",
   "link": "70"
  },
  {
   "id": 20,
   "s": 2650,
   "sEnd": 2743,
   "kind": "corner",
   "pre": [],
   "post": [],
   "tokens": [
    "flat",
    "left"
   ],
   "text": "FLAT LEFT",
   "dir": "left",
   "limitSpeed": 47.55078162122834,
   "minRadius": 307.4286715622356,
   "angleDeg": 14.52049959761495,
   "grade": "flat",
   "link": "120"
  },
  {
   "id": 21,
   "s": 2868,
   "sEnd": 2880,
   "kind": "hazard",
   "pre": [
    "crest"
   ],
   "post": [],
   "tokens": [
    "crest"
   ],
   "text": "CREST",
   "link": "40"
  },
  {
   "id": 22,
   "s": 2917.5,
   "sEnd": 2925.5,
   "kind": "hazard",
   "pre": [
    "double_caution",
    "washout"
   ],
   "post": [],
   "tokens": [
    "double caution",
    "washout"
   ],
   "text": "DOUBLE CAUTION · WASHOUT",
   "link": "70"
  },
  {
   "id": 23,
   "s": 2997,
   "sEnd": 3009,
   "kind": "hazard",
   "pre": [
    "crest"
   ],
   "post": [],
   "tokens": [
    "crest"
   ],
   "text": "CREST",
   "link": "80"
  },
  {
   "id": 24,
   "s": 3087,
   "sEnd": 3099,
   "kind": "hazard",
   "pre": [
    "dip"
   ],
   "post": [],
   "tokens": [
    "dip"
   ],
   "text": "DIP",
   "link": "100"
  },
  {
   "id": 25,
   "s": 3201,
   "sEnd": 3213,
   "kind": "hazard",
   "pre": [
    "caution",
    "jump"
   ],
   "post": [],
   "tokens": [
    "caution",
    "jump"
   ],
   "text": "CAUTION · JUMP",
   "link": "50"
  },
  {
   "id": 26,
   "s": 3267,
   "sEnd": 3279,
   "kind": "hazard",
   "pre": [
    "crest"
   ],
   "post": [],
   "tokens": [
    "crest"
   ],
   "text": "CREST",
   "link": "40"
  },
  {
   "id": 27,
   "s": 3321,
   "sEnd": 3326,
   "kind": "hazard",
   "pre": [
    "onto_tarmac"
   ],
   "post": [],
   "tokens": [
    "onto tarmac"
   ],
   "text": "ONTO TARMAC",
   "link": "and"
  },
  {
   "id": 28,
   "s": 3355,
   "sEnd": 3391,
   "kind": "corner",
   "pre": [
    "potholes"
   ],
   "post": [],
   "tokens": [
    "potholes",
    "square",
    "right"
   ],
   "text": "POTHOLES · SQUARE RIGHT",
   "dir": "right",
   "limitSpeed": 11.114607447623968,
   "minRadius": 12.939716958808354,
   "angleDeg": 89.95493590729313,
   "grade": "square",
   "link": "100"
  },
  {
   "id": 29,
   "s": 3504,
   "sEnd": 3546,
   "kind": "corner",
   "pre": [],
   "post": [],
   "tokens": [
    "square",
    "left"
   ],
   "text": "SQUARE LEFT",
   "dir": "left",
   "limitSpeed": 10.822443586771598,
   "minRadius": 12.295583098574484,
   "angleDeg": 90.67689851268973,
   "grade": "square",
   "link": "70"
  },
  {
   "id": 30,
   "s": 3616,
   "sEnd": 3700,
   "kind": "corner",
   "pre": [],
   "post": [],
   "tokens": [
    "four",
    "right"
   ],
   "text": "4 RIGHT",
   "dir": "right",
   "limitSpeed": 25.63323900016784,
   "minRadius": 73.4554436813045,
   "angleDeg": 44.932237030918905,
   "grade": "4",
   "link": "into"
  },
  {
   "id": 31,
   "s": 3700,
   "sEnd": 3705,
   "kind": "hazard",
   "pre": [
    "onto_gravel"
   ],
   "post": [],
   "tokens": [
    "onto gravel"
   ],
   "text": "ONTO GRAVEL",
   "link": "into"
  },
  {
   "id": 32,
   "s": 3714,
   "sEnd": 3722,
   "kind": "hazard",
   "pre": [
    "caution",
    "washout"
   ],
   "post": [],
   "tokens": [
    "caution",
    "washout"
   ],
   "text": "CAUTION · WASHOUT",
   "link": "40"
  },
  {
   "id": 33,
   "s": 3750,
   "sEnd": 3751,
   "kind": "stage",
   "pre": [],
   "post": [],
   "tokens": [
    "split"
   ],
   "text": "SPLIT"
  },
  {
   "id": 34,
   "s": 3766,
   "sEnd": 3786,
   "kind": "hazard",
   "pre": [
    "caution",
    "water_splash"
   ],
   "post": [],
   "tokens": [
    "caution",
    "water splash"
   ],
   "text": "CAUTION · WATER SPLASH",
   "link": "30"
  },
  {
   "id": 35,
   "s": 3820,
   "sEnd": 3895,
   "kind": "corner",
   "pre": [],
   "post": [],
   "tokens": [
    "two",
    "left",
    "plus"
   ],
   "text": "2 LEFT+",
   "dir": "left",
   "limitSpeed": 17.18737408160162,
   "minRadius": 42.92771127540855,
   "angleDeg": 70.32637985281036,
   "refine": "plus",
   "grade": "2",
   "link": "into"
  },
  {
   "id": 36,
   "s": 3895,
   "sEnd": 3913,
   "kind": "hazard",
   "pre": [
    "caution",
    "mud",
    "ruts",
    "potholes"
   ],
   "post": [],
   "tokens": [
    "caution",
    "mud",
    "ruts",
    "potholes"
   ],
   "text": "CAUTION · MUD · RUTS · POTHOLES",
   "link": "40"
  },
  {
   "id": 37,
   "s": 3951,
   "sEnd": 3983,
   "kind": "hazard",
   "pre": [
    "caution",
    "narrows",
    "bridge"
   ],
   "post": [],
   "tokens": [
    "caution",
    "narrows",
    "bridge"
   ],
   "text": "CAUTION · NARROWS · BRIDGE",
   "link": "and"
  },
  {
   "id": 38,
   "s": 4004,
   "sEnd": 4101,
   "kind": "corner",
   "pre": [],
   "post": [],
   "tokens": [
    "four",
    "right",
    "minus",
    "long"
   ],
   "text": "4 RIGHT− · LONG",
   "dir": "right",
   "limitSpeed": 23.594067929220536,
   "minRadius": 83.08923923655851,
   "angleDeg": 49.40688158143363,
   "refine": "minus",
   "length": "long",
   "grade": "4",
   "link": "into"
  },
  {
   "id": 39,
   "s": 4105,
   "sEnd": 4119,
   "kind": "hazard",
   "pre": [
    "loose"
   ],
   "post": [],
   "tokens": [
    "loose"
   ],
   "text": "LOOSE",
   "link": "60"
  },
  {
   "id": 40,
   "s": 4179,
   "sEnd": 4292,
   "kind": "corner",
   "pre": [],
   "post": [
    "dont_cut"
   ],
   "tokens": [
    "three",
    "right",
    "long",
    "opens",
    "four",
    "don't cut"
   ],
   "text": "3 RIGHT · LONG · OPENS 4 · DON'T CUT",
   "dir": "right",
   "limitSpeed": 20.11365263183602,
   "minRadius": 60.10422751045044,
   "angleDeg": 64.33182496708436,
   "shape": "opens",
   "length": "long",
   "grade": "3",
   "shapeGrade": "4",
   "link": "and"
  },
  {
   "id": 41,
   "s": 4314.5,
   "sEnd": 4335.5,
   "kind": "hazard",
   "pre": [
    "caution",
    "mud",
    "ruts",
    "potholes"
   ],
   "post": [],
   "tokens": [
    "caution",
    "mud",
    "ruts",
    "potholes"
   ],
   "text": "CAUTION · MUD · RUTS · POTHOLES",
   "link": "50"
  },
  {
   "id": 42,
   "s": 4385,
   "sEnd": 4445,
   "kind": "corner",
   "pre": [],
   "post": [],
   "tokens": [
    "one",
    "left",
    "plus",
    "long"
   ],
   "text": "1 LEFT+ · LONG",
   "dir": "left",
   "limitSpeed": 12.718302532545719,
   "minRadius": 21.832537379112306,
   "angleDeg": 92.76188008738715,
   "refine": "plus",
   "length": "long",
   "grade": "1",
   "link": "and"
  },
  {
   "id": 43,
   "s": 4470,
   "sEnd": 4482,
   "kind": "hazard",
   "pre": [
    "double_caution",
    "washout",
    "dip"
   ],
   "post": [],
   "tokens": [
    "double caution",
    "washout",
    "dip"
   ],
   "text": "DOUBLE CAUTION · WASHOUT · DIP",
   "link": "30"
  },
  {
   "id": 44,
   "s": 4515,
   "sEnd": 4631,
   "kind": "corner",
   "pre": [],
   "post": [],
   "tokens": [
    "five",
    "right",
    "minus",
    "long"
   ],
   "text": "5 RIGHT− · LONG",
   "dir": "right",
   "limitSpeed": 29.83351812847966,
   "minRadius": 128.0672471430699,
   "angleDeg": 39.360464598282235,
   "refine": "minus",
   "length": "long",
   "grade": "5",
   "link": "and"
  },
  {
   "id": 45,
   "s": 4647.5,
   "sEnd": 4661.5,
   "kind": "hazard",
   "pre": [
    "mud"
   ],
   "post": [],
   "tokens": [
    "mud"
   ],
   "text": "MUD",
   "link": "40"
  },
  {
   "id": 46,
   "s": 4700,
   "sEnd": 4786,
   "kind": "corner",
   "pre": [],
   "post": [
    "dont_cut"
   ],
   "tokens": [
    "two",
    "left",
    "plus",
    "long",
    "tightens",
    "late",
    "don't cut"
   ],
   "text": "2 LEFT+ · LONG · TIGHTENS LATE · DON'T CUT",
   "dir": "left",
   "limitSpeed": 14.062810423784725,
   "minRadius": 27.383642081265066,
   "angleDeg": 105.57601738103502,
   "shape": "tightens_late",
   "refine": "plus",
   "length": "long",
   "grade": "2",
   "link": "70"
  },
  {
   "id": 47,
   "s": 4857,
   "sEnd": 4869,
   "kind": "hazard",
   "pre": [
    "double_caution",
    "big_jump"
   ],
   "post": [],
   "tokens": [
    "double caution",
    "big jump"
   ],
   "text": "DOUBLE CAUTION · BIG JUMP",
   "link": "70"
  },
  {
   "id": 48,
   "s": 4935,
   "sEnd": 5033,
   "kind": "corner",
   "pre": [],
   "post": [],
   "tokens": [
    "three",
    "right",
    "plus",
    "long"
   ],
   "text": "3 RIGHT+ · LONG",
   "dir": "right",
   "limitSpeed": 22.143594046423146,
   "minRadius": 73.11235728947499,
   "angleDeg": 57.58288143440878,
   "refine": "plus",
   "length": "long",
   "grade": "3",
   "link": "into"
  },
  {
   "id": 49,
   "s": 5041,
   "sEnd": 5055,
   "kind": "hazard",
   "pre": [
    "caution",
    "potholes"
   ],
   "post": [],
   "tokens": [
    "caution",
    "potholes"
   ],
   "text": "CAUTION · POTHOLES",
   "link": "100"
  },
  {
   "id": 50,
   "s": 5166,
   "sEnd": 5273,
   "kind": "corner",
   "pre": [],
   "post": [],
   "tokens": [
    "six",
    "left",
    "long"
   ],
   "text": "6 LEFT · LONG",
   "dir": "left",
   "limitSpeed": 39.663881660951496,
   "minRadius": 215.72906461545782,
   "angleDeg": 23.062546571830737,
   "length": "long",
   "grade": "6",
   "link": "70"
  },
  {
   "id": 51,
   "s": 5326,
   "sEnd": 5327,
   "kind": "stage",
   "pre": [],
   "post": [],
   "tokens": [
    "one hundred",
    "flying finish"
   ],
   "text": "100 · FLYING FINISH"
  },
  {
   "id": 52,
   "s": 5341,
   "sEnd": 5353,
   "kind": "hazard",
   "pre": [
    "dip"
   ],
   "post": [],
   "tokens": [
    "dip"
   ],
   "text": "DIP",
   "link": "40"
  },
  {
   "id": 53,
   "s": 5391.5,
   "sEnd": 5399.5,
   "kind": "hazard",
   "pre": [
    "caution",
    "washout"
   ],
   "post": [],
   "tokens": [
    "caution",
    "washout"
   ],
   "text": "CAUTION · WASHOUT"
  },
  {
   "id": 54,
   "s": 5675,
   "sEnd": 5676,
   "kind": "stage",
   "pre": [],
   "post": [],
   "tokens": [
    "stop"
   ],
   "text": "STOP"
  }
 ]
}
